// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"addForm_AddNewGoalPop__5-QcC","modalBody":"addForm_modalBody__jRkWM","formControl":"addForm_formControl__ni4fE","add":"addForm_add__Bvsud"};